import { useGetProject } from "~/api/projects/projects";
import { useProjectParams } from "~/helpers";

export const useParentCase = () => {
  const { organizationId, caseId } = useProjectParams();
  const { data: currentCase } = useGetProject(organizationId, caseId);
  const { data: parentCase } = useGetProject(
    organizationId,
    currentCase?.parentId || ""
  );

  const hasParent = !!currentCase?.parentId;

  const project = hasParent ? parentCase : currentCase;

  const isNested = currentCase?.parentId !== null;
  const isMaster = currentCase?.parentId === null;

  return { project, isNested, isMaster };
};
